import React from 'react';
import { toast } from 'react-toastify';
import './search.css';

// Info toast with an Undo button (no native dialogs anywhere).
export const undoToast = (message, onUndo) =>
  toast(
    ({ closeToast }) => (
      <span className="ss-toast">
        <span>{message}</span>
        <button
          type="button"
          className="ss-toast-btn"
          onClick={() => {
            if (onUndo) onUndo();
            if (closeToast) closeToast();
          }}
        >
          Undo
        </button>
      </span>
    ),
    { type: toast.TYPE.INFO, autoClose: 5000 }
  );
